import React from "react";
import { ProductCardProps } from "./MProductCard";
import { formatPrice, handleLogin } from "Utils/common";
import { getYourPriceLabel, handleContactUs, showListPriceLabel } from "Utils/activityHelper";
interface PriceWidgetProps extends ProductCardProps {
  size?: "small" | "medium" | "large";
  placeholder?: string;
}
const MPriceWidget2: React.FC<PriceWidgetProps> = (props) => {
  const { product, loginState, placeholder, previewData, isOrderPreviewFlag } =
    props;
  const {
    listPrice,
    finalPrice,
    promoPrice,
    priceStatus,
    level1Qty,
    level1Price,
    level2Qty,
    level2Price,
    priceType,
  } = product;


  const priceItems = () => {
    if (priceStatus === "ContactUs") {
      return (
        <div>
          {listPrice && (
            <span className="priceItem lightText lineThrough">
              {formatPrice(listPrice) || ""}
            </span>
          )}
          <span
            className="textLink"
            onClick={() => {
              handleContactUs(loginState);
            }}
          >
            联系我们
          </span>
        </div>
      );
    }
    if (priceStatus === "LoginRequired")
      return (
        <div>
          <span className="textLink" onClick={handleLogin}>
            登录可见
          </span>
          {listPrice && (
            <span className="priceItem lightText lineThrough">
              {formatPrice(listPrice) || ""}
            </span>
          )}
        </div>
      );
    if (priceStatus === "Preview")
      return <div className="lightText">{formatPrice(finalPrice)}</div>;
    <div className="row">
      <span className="lightText">{formatPrice(finalPrice)}</span>;
      {listPrice && (
        <span className="priceItem lightText lineThrough">
          {formatPrice(listPrice) || ""}
        </span>
      )}
    </div>;
    return (
      <>
        <div className="row">
          {level1Qty && level1Price && (
            <span className="lightText priceItem">
              <span>
                {" "}
                {level1Qty}
                {"件"}
              </span>
              <span style={{ paddingLeft: "5px" }}>
                {formatPrice(level1Price)}
              </span>
            </span>
          )}
          {level2Qty && level2Price && (
            <span className="priceItem highlight">
              <span>
                {level2Qty}
                {"件"}
              </span>
              <span style={{ paddingLeft: "5px" }}>
                {formatPrice(level2Price)}
              </span>
            </span>
          )}
        </div>
        <div className="row">
          {listPrice && (
            <div>
              {showListPriceLabel({previewData, isOrderPreviewFlag})}
              <span className="priceItem lightText lineThrough">
                {formatPrice(listPrice) || ""}
              </span>
              </div>
          )}
          {placeholder === "cartItem" ? (
            <>
              {promoPrice && (
                <span className={`primaryText priceItem`}>
                  {formatPrice(promoPrice)}
                </span>
              )}
              {promoPrice !== '0.00' && finalPrice && (
                <span className={`primaryText priceItem`}>
                  <span style={{fontWeight: 600}}>{formatPrice(finalPrice)}</span>
                  <span style={{paddingLeft: '4px', fontSize: '12px'}}>{"折后"}</span>
                </span>
              )}
            </>
          ) : (
            <>
              {finalPrice !== null && finalPrice !== undefined && finalPrice !== "" && (
                <span className={`primaryText priceItem`}>
                  {getYourPriceLabel({
                    priceType,
                    previewData,
                    isOrderPreviewFlag,
                  })}
                  {formatPrice(finalPrice)}
                </span>
              )}
            </>
          )}
        </div>
      </>
    );
  };

  return (
    <div className={`priceWrapper ${props.size || ""}`}>{priceItems()}</div>
  );
};

export default MPriceWidget2;
